import React from "react";
import styled from "styled-components";
import "react-h5-audio-player/lib/styles.css";
import AudioPlayer from "react-h5-audio-player";
import IconButton from "@mui/material/IconButton";
import SystemUpdateAltIcon from "@mui/icons-material/SystemUpdateAlt";

const Container = styled.div`
  position: relative;

  .download-btn {
    position: absolute;
    top: -25px;
    right: 5px;
  }
`;

const DownloadButton = (props) => {
  const downloadFile = () => {
    window.location.href = props.src;
  };
  return (
    <IconButton className="download-btn" aria-label="delete" onClick={downloadFile}>
      <SystemUpdateAltIcon fontSize="small" />
    </IconButton>
  );
};

const Player = ({ src }) => (
  <Container>
    <DownloadButton src={src} />
    <AudioPlayer
      style={{ width: "100%", boxShadow: "none" }}
      autoPlay={false}
      src={src}
      showSkipControls={false}
      showJumpControls={false}
      customAdditionalControls={[]}
      layout="horizontal"
    />
  </Container>
);

export { DownloadButton, Player };

export default Player;
